module.exports = __webpack_public_path__ + "static/media/manage-users.f7acb968.svg";